import styled from 'styled-components';

export const Container = styled.div`
    position: fixed;
    top: 50%;
    left: -125px;
    z-index: 100;
    transform: translate3d(0, -50%, 0);
    transition: all .4s ease 0s;

    &.visible {
        left: -80px;
    }

    &.visible.opened {
        left: -2px;
    }
`;

export const CharactersList = styled.div`
    width: 80px;
    background-color: #111;
    border: 1px solid #333;
    color: #fff;
`;

export const Title = styled.div`
    text-transform: uppercase;
    color: #777;
    font-size: 10px;
    padding: 5px;
    text-align: center;
`;

export const ShortcutItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all .4s ease 0s;
    padding: 5px 0;

    &:hover {
        background-color: #444;
    }

`;

export const ShortcutName = styled.div`
    text-align: center;
    font-size: 10px;
    width: 100%;
`;

export const ShortcutImage = styled.div`
    width: 40px;
    height: 40px;
    position: relative;
    margin-bottom: 5px;
    border-radius: 20px;
    overflow: hidden;
`;

export const EmptyImage = styled.div`
    background-color: #222;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    &:before {
        content: '?';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #313131;
        font-size: 40px;
        font-weight: 900;
    }
`;


export const Open = styled.div`
    position: absolute;
    top: calc(50% - 10px);
    right: -28px;
    width: 30px;
    height: 30px;
    background-color: #111;
    border: 1px solid #333;
    border-left: 1px solid #111;
    cursor: pointer;

    &:before {
        content: '\\F0142';
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        color: #fff;
        font-size: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        transition: all .4s ease 0s;
    }

    ${Container}.opened &:before {
        transform: rotate(-180deg);
    }
`;